import { gql } from '@apollo/client'

export const ASSURANCES_QUERY = gql`
  query Assurances($coproprieteId: bigint!) {
    assurances: d4_assurance(where: { copropriete_id: { _eq: $coproprieteId } }) {
      id
      police
      typeassurance
      courtier {
        id
        raisonsociale
      }
      compagniedassurance {
        id
        raisonsociale
      }
    }
  }
`
